import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Switch,
  Typography,
} from '@material-ui/core';
import { useField } from 'formik';
import React, { useCallback, useState } from 'react';

import useAxleDeletes from 'core/hooks/useAxleDeletes';
import useVehicleAxles from 'core/hooks/useVehicleAxles';
import { useErrorNotifications } from 'core/http';
import { VehicleFormSchema } from 'core/schemas/vehicleForm';
import { InputField } from 'Elements/Form';
import { useSchemaMeta } from 'Elements/Form/Schema';
import Axle from 'Elements/TireMap/Axle';

export default function VehicleTireMap() {
  const { vehicleId } = useSchemaMeta<{ vehicleId: number }>();
  const [{ value: axlesEnabled }] = useField<
    VehicleFormSchema['vehicle']['axles_enabled']
  >('vehicle.axles_enabled');

  return (
    <Card elevation={1}>
      <CardHeader
        title="Rengaskartta"
        action={
          !vehicleId && (
            <InputField
              component={Switch}
              name="vehicle.axles_enabled"
              type="checkbox"
            />
          )
        }
      />

      {axlesEnabled && (
        <CardContent>
          {!vehicleId ? (
            <Typography variant="h4" align="center">
              Voit luoda rengaskartan kun olet tallentanut ensin perustiedot.
            </Typography>
          ) : (
            <TireMap vehicleId={vehicleId} />
          )}
        </CardContent>
      )}
    </Card>
  );
}

function TireMap({ vehicleId }: { vehicleId: number }) {
  const { axles, create, creating, remove } = useVehicleAxles(vehicleId);
  const showErrorNotification = useErrorNotifications();

  const deleteAxle = useAxleDeletes();
  const [deleting, setDeleting] = useState(false);

  const onAxleDelete = useCallback(
    (id: number, index: number) => {
      if (deleting) {
        return;
      }

      setDeleting(true);

      deleteAxle(id, vehicleId)
        .then(() => {
          remove(index);
        })
        .catch(showErrorNotification)
        .finally(() => setDeleting(false));
    },
    [deleteAxle, deleting, remove, showErrorNotification, vehicleId]
  );

  return (
    <Grid container direction="column" spacing={3}>
      {axles.map((axle, index) => (
        <Axle
          key={index}
          axle={axle}
          index={index}
          onDeleteClick={onAxleDelete}
          isLast={index === axles.length - 1}
        />
      ))}

      <Grid item xs={12} container justify="center">
        {creating ? (
          <CircularProgress />
        ) : (
          <Button onClick={create} variant="contained">
            Lisää akseli
          </Button>
        )}
      </Grid>
    </Grid>
  );
}
